// extracted by mini-css-extract-plugin
module.exports = {"root":"Swatch_root___DVwi","swatchValue":"Swatch_swatchValue__PxIqC","swatchLabel":"Swatch_swatchLabel__tpSz0","image":"Swatch_image___DFVb"};